import React from "react";

const Header = () => {
  return (
    <div className="px-4 sm:px-10 pt-10">
      <div className="flex justify-between items-center gap-6">
        <h1 className="font-bold text-text1 whitespace-nowrap text-[24px] sm:text-[26px] md:text-[30px]">
          Products
        </h1>
      </div>
      <hr className="mb-4 border-gray-300 mt-6 " />
    </div>
  );
};

export default Header;
